/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Icon, Image, Text, View } from "@aws-amplify/ui-react";
export default function HeroSection(props) {
  const { overrides, ...rest } = props;
  return (
    <View
      width="1439px"
      height="710px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "HeroSection")}
      {...rest}
    >
      <Flex
        gap="10px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        position="absolute"
        top="-10px"
        left="353px"
        padding="10px 10px 10px 10px"
        {...getOverrideProps(overrides, "Frame 1160464546")}
      >
        <Image
          width="1171px"
          height="710px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          objectFit="cover"
          {...getOverrideProps(overrides, "ikimy hero image 1")}
        ></Image>
      </Flex>
      <View
        width="1461px"
        height="709px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="0.14%"
        bottom="0%"
        left="0%"
        right="-1.53%"
        padding="0px 0px 0px 0px"
        backgroundImage="linear-gradient(0deg, rgba(34,66,114,1), rgba(34,66,114,0))"
        {...getOverrideProps(overrides, "Rectangle 39557")}
      ></View>
      <Icon
        width="835.55px"
        height="1178.58px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 835.5511474609375,
          height: 1178.57763671875,
        }}
        paths={[
          {
            d: "M437.504 5.83109L417.776 36.2888L397.973 5.87924C409.984 -1.94225 425.474 -1.96112 437.504 5.83109ZM417.776 1142.29L398.047 1172.75C410.077 1180.54 425.567 1180.52 437.578 1172.7L417.776 1142.29ZM417.827 80.4042C408.191 87.3206 395.462 96.7396 380.568 108.425C345.783 135.715 299.493 175.131 253.325 223.665C159.655 322.137 72.5776 451.759 72.5776 589.95C72.5776 728.117 159.633 857.403 253.284 955.53C299.444 1003.9 345.727 1043.15 380.506 1070.31C395.38 1081.93 408.095 1091.29 417.724 1098.17C427.36 1091.26 440.089 1081.84 454.983 1070.15C489.768 1042.86 536.058 1003.45 582.226 954.912C675.896 856.441 762.974 726.819 762.974 588.628C762.974 450.461 675.919 321.175 582.267 223.048C536.107 174.682 489.825 135.432 455.045 108.266C440.171 96.6484 427.456 87.2836 417.827 80.4042ZM634.771 172.939C731.863 274.671 835.551 421.556 835.551 588.628C835.551 755.678 731.885 902.886 634.812 1004.93C585.608 1056.66 536.526 1098.43 499.782 1127.25C481.381 1141.69 465.999 1152.94 455.143 1160.63C449.713 1164.48 445.41 1167.44 442.421 1169.46C440.927 1170.48 439.76 1171.26 438.945 1171.8C438.538 1172.07 438.218 1172.28 437.99 1172.43L437.715 1172.61L437.629 1172.67L437.599 1172.68C437.588 1172.69 437.578 1172.7 417.776 1142.29C398.047 1172.75 398.037 1172.74 398.026 1172.73L397.91 1172.66L397.635 1172.48C397.406 1172.33 397.086 1172.12 396.678 1171.85C395.863 1171.31 394.696 1170.53 393.201 1169.53C390.211 1167.51 385.907 1164.56 380.476 1160.74C369.618 1153.08 354.234 1141.88 335.83 1127.51C299.081 1098.8 249.992 1057.2 200.78 1005.64C103.688 903.906 0 757.022 0 589.95C0 422.9 103.666 275.692 200.739 173.643C249.943 121.917 299.025 80.1506 335.769 51.3232C354.17 36.8866 369.552 25.6366 380.408 17.9469C385.838 14.1007 390.141 11.1412 393.13 9.1152C394.624 8.10208 395.791 7.322 396.606 6.78083C397.013 6.51022 397.333 6.29931 397.562 6.14881C397.676 6.07356 397.768 6.01341 397.837 5.96846L397.952 5.89297C397.963 5.88563 397.973 5.87924 417.776 36.2888C437.504 5.83109 437.514 5.83747 437.525 5.8448L437.555 5.8642L437.641 5.92004L437.781 6.01173L437.916 6.09965C438.145 6.2495 438.465 6.45945 438.873 6.72879C439.688 7.26744 440.855 8.04378 442.35 9.05204C445.34 11.0683 449.644 14.0136 455.075 17.8417C465.933 25.4953 481.317 36.6938 499.721 51.0686C536.47 79.7727 585.559 121.375 634.771 172.939Z",
            fill: "rgba(204,164,59,0.62)",
            fillRule: "evenodd",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="-38.35%"
        bottom="-27.65%"
        left="43.44%"
        right="-1.5%"
        {...getOverrideProps(overrides, "Vector (Stroke)")}
      ></Icon>
      <Flex
        gap="10px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        position="absolute"
        top="28.31%"
        bottom="28.17%"
        left="calc(50% - 235px - 409.5px)"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1045")}
      >
        <Flex
          gap="10px"
          direction="column"
          width="470px"
          height="309px"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "HeroHeader")}
        >
          <Icon
            width="142.62px"
            height="42px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 146.23348857981728,
              height: 56.67824910539457,
            }}
            paths={[
              {
                d: "M0.290065 41.9886C46.5278 17.183 93.6027 7.63103 140.36 10.741C141.289 10.8032 142.601 8.73873 142.624 5.88C142.648 2.96878 141.292 0.906719 140.36 0.818794C93.2085 -3.68245 46.4619 10.4916 0.167371 40.4648C-0.126869 40.6558 0.000334304 42.1445 0.290065 41.9886Z",
                fill: "rgba(204,164,59,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            shrink="0"
            position="relative"
            {...getOverrideProps(overrides, "Fill 90")}
          ></Icon>
          <Flex
            gap="32px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 101")}
          >
            <Text
              fontFamily="Inter"
              fontSize="56px"
              fontWeight="700"
              color="rgba(254,254,254,1)"
              lineHeight="60px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="470px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Ikimy gets you &#x2028;discovered"
              {...getOverrideProps(
                overrides,
                "Ikimy gets you \u2028discovered"
              )}
            ></Text>
            <Text
              fontFamily="Inter"
              fontSize="20px"
              fontWeight="400"
              color="rgba(255,255,255,1)"
              lineHeight="34px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="445px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Get ready to be seen and discover endless career possibilities with Ikimy."
              {...getOverrideProps(
                overrides,
                "Get ready to be seen and discover endless career possibilities with Ikimy."
              )}
            ></Text>
            <Flex
              gap="0"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              borderRadius="8px"
              padding="12px 32px 12px 32px"
              backgroundColor="rgba(203,163,58,1)"
              {...getOverrideProps(overrides, "ButtonTesting")}
            >
              <Text
                fontFamily="Inter"
                fontSize="22px"
                fontWeight="700"
                color="rgba(255,255,255,1)"
                lineHeight="33px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Find  your Fit"
                {...getOverrideProps(overrides, "label")}
              ></Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </View>
  );
}
